import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Context from "../Context";

const Logout = () => {
  const { callApi, profileState, setProfileState } = Context();
  const history = useNavigate();
  useEffect(() => {
    console.log(history);
    if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
      callApi("users-logout", profileState);
      localStorage.removeItem("accessToken");
      setProfileState({});
      history("/");
    } else {
    }
    // eslint-disable-next-line
  }, []);
  return <div> logout</div>;
};
export default Logout;
